import { GE_ADV_WIZARD_URL_SEGMENT } from "features/score-types/ge-adv/constants/ge-adv-routing.constants";

export interface SitemapNode {
  route: string;
  icon?: string;
  text?: string;
  children?: SitemapNode[];
  default?: boolean;
}

const reportNode: SitemapNode = {
  route: "report",
  icon: "chart-line",
  children: [
    {
      route: "est",
      text: "EST",
    },
    {
      route: GE_ADV_WIZARD_URL_SEGMENT,
      text: "GE ADV",
    },
    {
      route: "nom",
      text: "NOM 036",
    },
  ],
};

export const sitemap: SitemapNode[] = [
  {
    route: "login",
    icon: "home",
    children: [{ route: "forgot-password" }],
  },
  {
    route: "homepage",
    icon: "home",
  },
  {
    route: "employees-list",
    icon: "briefcase-account-outline",
    children: [
      {
        route: "employee",
        icon: "account-hard-hat",
        children: [reportNode],
      },
    ],
  },
  {
    route: "reports-list",
    icon: "table",
    children: [{ ...reportNode, default: true }],
  },
  {
    route: "shared-report",
  },
  {
    route: "upload",
    icon: "file-upload-outline",
    children: [{ route: "manual" }],
  },
  {
    route: "compare",
    icon: "account-supervisor",
  },
  {
    route: "learn",
    icon: "school",
    children: [
      {
        route: "video-library",
        icon: "filmstrip-box-multiple",
      },
      {
        route: "help",
        icon: "help-circle",
      },
    ],
  },

  {
    route: "dev",
    icon: "account-lock-outline",
  },
  {
    route: "admin",
    icon: "account-lock",
  },
  {
    route: "not-found",
  },
];
